import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Zone from "../Components/Zone";

const ZoneDataAdmin = () => {
  const navigate = useNavigate();
  const [userlog, setUserlog] = useState(localStorage.getItem("Logkey"));

  useEffect(() => {
    if (userlog === undefined || userlog === null) {
      navigate("/");
    }
  }, []);

  return (
    <>
      <Header />
      <Sidebar />
      <Zone />
      {/* <Footer/>    */}
    </>
  );
};

export default ZoneDataAdmin;
